import React from 'react';

import { useHistory, useLocation } from 'react-router-dom'; // Importar useHistory para redirigir
import { Button, Col, Image, Container } from 'react-bootstrap';
import logo from '../../assets/images/parrotfy-logo.svg';

function OnboardingFailure() {
  const history = useHistory();
  const location = useLocation();

  // Check if iframe mode is enabled
  const searchParams = new URLSearchParams(location.search);
  const isIframeMode = searchParams.get('format') === 'iframe';

  const handleRedirect = () => {
    history.push({
      pathname: '/onboarding',
      search: isIframeMode ? '?format=iframe' : ''
    });
  };

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center px-0 mx-0 "
      style={{ minHeight: '80vh' }}
    >
      <Col className="d-flex flex-column justify-content-center align-items-center text-center">
        {!isIframeMode && <Image src={logo} alt="Logo" className="img-fluid mb-3" />}
        <p className="mb-0 pb-0 finished-title">
          ¡Lo lamentamos{' '}
          <span role="img" aria-label="sad face with tear">
            😢
          </span>
          !
        </p>
        <p className="finished-subtitle">Hubo un error, por favor vuelve a intentarlo</p>

        <Button className="mt-3" onClick={handleRedirect}>
          <span className="px-4 py-0">Volver a intentarlo</span>
        </Button>
      </Col>
    </Container>
  );
}

export default OnboardingFailure;
